import { useTranslation } from "react-i18next";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthLayout from "layouts/AuthLayout";
import Button from "components/Button";
import PingAnimation from "components/PingAnimation";
import { useAuth0 } from "@auth0/auth0-react";
import Alert from "components/Alert";
import { userStore } from "store/UserStore";
import { observer } from "mobx-react-lite";
import { ORG_ACCORDION_STATUS_KEY } from "utils";
import { ROUTES_ENUM } from "routes/consts";

const LogIn = () => {
  const { t } = useTranslation();
  const { isLoading, loginWithRedirect } = useAuth0();
  const { onboarded } = userStore;
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = async (event: React.FormEvent, signup?: boolean) => {
    event.preventDefault();
    localStorage.removeItem(ORG_ACCORDION_STATUS_KEY);
    try {
      await loginWithRedirect({
        redirectUri:
          location.pathname === "/revit-setup"
            ? import.meta.env.VITE_REVIT_URL
            : "",
        screen_hint: signup ? "signup" : "login",
      });
      console.log("login submitted ✅");
      onboarded
        ? navigate(`/${ROUTES_ENUM.DASHBOARD}`, { replace: true })
        : navigate(`/${ROUTES_ENUM.ONBOARDING}`, { replace: true });
    } catch (error) {
      console.error("error", error);
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="min-h-screen justify-center flex items-center">
          <PingAnimation size="large" color="gray" />
        </div>
      ) : (
        <AuthLayout className="min-h-screen max-h-screen">
          <div className="text-left min-w-full">
            {location.state === "confirm" && (
              <Alert
                type="success"
                title={t("signIn.successfullyVerified")}
                className="mb-5"
              />
            )}
            <div className="flex items-center justify-center gap-4">
              <Button
                type="gray"
                htmlType="submit"
                disabledClasses="w-full"
                className="font-light"
                onClick={(e) => handleLogin(e, true)}
                testID="signup_button"
              >
                {t("signIn.signUp")}
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                disabledClasses="w-full"
                className="font-light"
                onClick={handleLogin}
                testID="login_button"
              >
                {t("signIn.signIn")}
              </Button>
            </div>
          </div>
        </AuthLayout>
      )}
    </>
  );
};

export default observer(LogIn);
